
import firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/messaging'
import { prodConfig, devConfig } from "../ConfigAplication"

const config = process.env.NODE_ENV === 'production'
    ? prodConfig
    : devConfig;

initFire();
export function initFire() {
    if (!firebase.apps.length) {
        firebase.initializeApp(config)
        firebase.firestore().settings({ timestampsInSnapshots: true })
        firebase.firestore().enablePersistence({ experimentalTabSynchronization: true })
            .then(function () {
                var db = firebase.firestore();
            })
            .catch(function (err) {
                console.log('err experimentalTabSynchronization', err);

                if (err.code == 'failed-precondition') {
                    // Multiple tabs open, persistence can only be enabled
                    // in one tab at a a time.
                    // ...
                } else if (err.code == 'unimplemented') {
                    // The current browser does not support all of the
                    // features required to enable persistence
                    // ...
                }
            });
    }
}

const auth = firebase.auth();
const firestore = firebase.firestore;
const storage = firebase.storage();

export {
    auth, firestore, storage
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js